import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {   
    getBankAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts`,
        isArray: true
    },
    getBankAccountsAsOptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/bankAccountsMinimal`,
        isArray: true
    },
    lookupBankAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/lookup`
    },
    createBankAccount: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankAccounts`
    },
    updateBankAccount: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId`
    },
    updateBankAccountbalances: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/updateBalances`
    },
    getReconciliations: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/reconciliations`
    },
    unreconcileAll: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/unreconcileAll`
    },
    getBankAccountsExtended: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts?includeExtendedInfo=true`,
        isArray: true
    },
    getBankAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId`
    },
    getBankAccountEpaySettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/epaySettings`
    },
    getCashSummaryForAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/:accountingBookType/cash/:id`,
        cache: true
    },
    getCompanyFunds: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/company/:id/funds`,
        isArray: true
    },
    getBankRegister: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/:bankGlAccountId/register`,
        params: {
            '$count': true
        }
    },
    getBankRegisterWithTimePeriod: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/:bankGlAccountId/register/wtp`
    },
    queryACHBillingForDeposits: {
        method: 'GET',
        isArray: true,
        url: `${BASE_PATH_API}/achBilling/holdDayOptions/deposits`
    },
    queryACHBillingForWithdrawals: {
        method: 'GET',
        isArray: true,
        url: `${BASE_PATH_API}/achBilling/holdDayOptions/withdrawals`
    },
    queryACHBillingAll: {
        method: 'GET',
        isArray: true,
        url: `${BASE_PATH_API}/achBilling/holdDayOptions/all`
    },
    sendLimitIncreaseRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/banking/epay/limitIncreaseRequest`
    },
    sendHoldDaysChangeRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/banking/epay/holdDaysChangeRequest`
    },
    sendBankAccountChangeRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/banking/epay/bankAccountChangeRequest`
    },
    sendControllerChangeRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/banking/epay/controllerChangeRequests`
    },
    inactivateBankAccountStatus: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/inactivate`
    },
    activateBankAccountStatus: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/activate`
    },
    deleteBankAccount: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId`
    },
    getAccountInactiveState: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/isInUse`
    },
    getBankAccountBalance: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/balance`
    },
    getBankAccountStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/status`
    },
    getActiveBankAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts`
    },
    DoesAccountHaveBankAccountWithAchSetUp: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/achEnabled`
    },
    getBankAccountProperties: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/properties`,
        params: {
            '$count': true
        }
    },
    getBalanceBreakdownByOwner: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/balanceBreakDown/:bankGlAccountId/byOwner`,
        params: {
            '$count': true
        }
    },
    getBalanceBreakDownByProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/balanceBreakDown/:bankGlAccountId/byProperty`,
        params: {
            '$count': true
        }
    },
    getBankReconciliation: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/reconciliations/:reconciliationId`
    },
    getFinalizeReconciliationReport: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:bankGlAccountId/reconciliations/finalizeReport`
    },
    getUnclearedJournalEntriesAsOfReconciliation: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/reconciliations/unclearedJournalEntries`
    },
    updateBankReconciliationAttachments: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bankAccounts/reconciliations/:reconciliationId/attachments`
    },
    finalizeBankReconciliation: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bankAccounts/reconciliations/finalize`
    },
    createBankReconciliation: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankAccounts/reconciliations`
    },
    updateBankReconciliation: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bankAccounts/reconciliations`
    },
    getBankAccountsQueuedForChecks: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/queuedForChecks`
    },
    getChecksToBePrint: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:id/checksToBePrint`
    },
    remoteCheckPrinting: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bankAccounts/:id/remoteCheckPrinting`
    },
    getUndepositedfunds: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:id/undepositedFunds`,
        isArray: true
    },
    getElectronicallyFundedTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/:id/electronicallyFundedTransactions`,
        isArray: true
    },
    updateBulkPropertyEpaySettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/paymentMethodSettings`
    },
    updateBulkRentalOwnersEpaySettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId/allRentalOwners`,
    },
    updateBankConvenienceFees: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId/eft`
    },
    updateCreditCardConvenienceFees: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId/creditCard`
    },
    getLeaseInfoForBanking: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/leaseSummary/:leaseId`
    },
    getUndepositedFundsAmount: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccount/:bankId/undepositedFunds`
    },
    undoLastReconciliation: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bankreconciliation/:bankGlAccountId/undoLastReconciliation`
    },
    undoPendingReconciliation: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bankreconciliation/:bankGlAccountId/undoPendingReconciliation`
    },
    finalizeAutomaticBankReconciliation: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankreconciliation/:bankGlAccountId/finalize/automatic`
    },
    saveReconciliationForLater: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankreconciliation/:bankGlAccountId/saveForLater`
    },
    finalizeManualBankReconciliation: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankreconciliation/:bankGlAccountId/finalize/manual`
    },
    undoLastReconciliationForLinkedAccount: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bankreconciliation/:bankGlAccountId/undoLastReconciliationForLinkedAccount`
    },
    numberOfPartiallyDepositedSplitPayments: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/numberOfPartiallyDepositedSplitPayments`
    },
    getBankAccountsWithPartialDepositsForSplitPayments: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankAccounts/partiallyDepositedSplitPayments`
    },
    getDefaultManagementFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/managementFeePolicy`
    },
    getAllAccountingBooks: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/allAccountingBooks`
    }
};

export function BankingApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.generateBalanceBreakdownByProperty = function generateBalanceBreakdownByProperty(params, bankGlAccountId) {
        return `${BASE_PATH_API}/banking/BalanceBreakDownReport/ByProperty/${bankGlAccountId}?${$httpParamSerializer(params)}`;
    };

    service.generateBalanceBreakdownByOwner = function generateBalanceBreakdownByOwner(params, bankGlAccountId) {
        return `${BASE_PATH_API}/banking/BalanceBreakDownReport/ByOwner/${bankGlAccountId}?${$httpParamSerializer(params)}`;
    };
    
    service.generateBankReconciliationReport = function generateBankReconciliationReport(params, reconciliationId) {
        return `${BASE_PATH_API}/banking/reconciliations/${reconciliationId}/report?${$httpParamSerializer(params)}`;
    };
    
    service.localCheckPrintingAndPreviewUrl = function localCheckPrintingAndPreviewUrl(params, bankAccountId) {
        return `${BASE_PATH_API}/bankAccounts/${bankAccountId}/localCheckPrinting?${$httpParamSerializer(params)}`;
    };

    return service;
}
BankingApi.$inject = [
    '$httpParamSerializer'
];
